import { useGameStore } from '../../store/gameStore';
import { getActorLabel } from '../../domain/phaseStatus';

export function OverviewHint() {
  const game = useGameStore((s) => s.game);
  const botActingPlayerIndex = useGameStore((s) => s.botActingPlayerIndex);
  const actorLabel = getActorLabel(game, botActingPlayerIndex);

  return (
    <div className="overlay-panel px-4 py-3 text-center">
      <p className="text-sm text-white/85">스크롤·핀치로 보드를 이동·확대할 수 있습니다</p>
      {botActingPlayerIndex !== null && actorLabel && (
        <p className="mt-1 animate-pulse text-sm font-semibold text-amber-300">{actorLabel}</p>
      )}
      <p className="mt-1 text-xs text-white/55">플레이하려면 하단 &apos;플레이&apos; 탭을 선택하세요</p>
    </div>
  );
}
